import React from 'react';
import PropTypes from 'prop-types';
import { dashesOnlyToCamelCase } from '@fundera/fundera-utilities';

import * as styles from './ShowOnly.module.less';

const ShowOnly = ({
  children,
  minBreakpoint = '5',
  render = 'span',
  fallback = null,
}) => {
  const Component = render;
  const css = dashesOnlyToCamelCase(`break-${minBreakpoint}`);
  const fallbackCss = dashesOnlyToCamelCase(`fallback-${minBreakpoint}`);
  return (
    <>
      <Component className={styles[css]}>{children}</Component>
      {fallback && (
        <Component className={styles[fallbackCss]}>{fallback}</Component>
      )}
    </>
  );
};

ShowOnly.propTypes = {
  children: PropTypes.node.isRequired,
  minBreakpoint: PropTypes.oneOf([
    'all',
    '5',
    'header-reduce-word',
    'header-how-works',
  ]),
  render: PropTypes.oneOf([PropTypes.func, PropTypes.string]),
  fallback: PropTypes.node,
};

ShowOnly.defaultProps = {
  minBreakpoint: '5',
  render: 'span',
  fallback: null,
};

export default ShowOnly;
